// Port of api/fuel/app/classes/filter/package/games/game/prepare/tags.php
export default {
	run: function(local, global) {
		var gameTags = (global.tags && global.tags.game && global.tags.game[local.game_id]) ? global.tags.game[local.game_id] : []
		var itemTags = (global.tags && global.tags.item && global.tags.item[local.id]) ? global.tags.item[local.id] : []
		local.tags = gameTags.concat(itemTags)
		return local
	}
}
